"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.optionPropType = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Option = _interopRequireWildcard(require("./Option.style"));

var _Icon = _interopRequireDefault(require("../../Icon"));

/* PureComponent instead of functional component
   is needed for performance */
var Option =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(Option, _PureComponent);

  function Option() {
    (0, _classCallCheck2.default)(this, Option);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Option).apply(this, arguments));
  }

  (0, _createClass2.default)(Option, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          option = _this$props.option,
          selected = _this$props.selected,
          handleClick = _this$props.handleClick,
          focused = _this$props.focused,
          index = _this$props.index,
          handleOptionHover = _this$props.handleOptionHover,
          CustomComponent = _this$props.customOption;
      return _react.default.createElement(_Option.default, {
        selected: selected,
        focused: focused,
        onClick: function onClick() {
          return handleClick(option, selected);
        },
        disabled: option.disabled,
        "data-index": index,
        onMouseEnter: handleOptionHover,
        className: "".concat(selected ? 'selected-option' : 'unselected-option')
      }, CustomComponent ? [_react.default.createElement(CustomComponent, {
        option: option
      }), selected ? _react.default.createElement(_Icon.default, {
        type: "check",
        style: {
          width: '16px',
          height: '16px'
        }
      }) : null] : _react.default.createElement(_Option.LabelContainer, null, option.label, selected ? _react.default.createElement(_Icon.default, {
        type: "check",
        style: {
          width: '16px',
          height: '16px'
        }
      }) : null));
    }
  }]);
  return Option;
}(_react.PureComponent);

var optionPropType = {
  value: _propTypes.default.string.isRequired,
  label: _propTypes.default.string.isRequired,
  disabled: _propTypes.default.bool,
  selected: _propTypes.default.bool
};
exports.optionPropType = optionPropType;
Option.defaultProps = {
  customOption: null,
  focused: false,
  selected: false,
  index: 0,
  handleClick: function handleClick() {
    return null;
  },
  handleOptionHover: function handleOptionHover() {
    return null;
  }
};
Option.propTypes = {
  option: _propTypes.default.shape(optionPropType).isRequired,
  focused: _propTypes.default.bool,
  selected: _propTypes.default.bool,
  customOption: _propTypes.default.func,
  index: _propTypes.default.number,
  handleClick: _propTypes.default.func,
  handleOptionHover: _propTypes.default.func
};
var _default = Option;
exports.default = _default;